//*************************************************************************************
//* WaMS Custom Validators
//* Version 1.0
//* Author: Damian Koch
//* JavaScript component of custom ComponentModel.DataAnnotations.ValidationAttribute
//* Adds client-side support of RequiredIf, and ValidYearDuration
//* Requires jQuery, jQuery.validate, jQuery.validate.unobtrusive
//*************************************************************************************
jQuery(function () {
    jQuery.validator.addMethod('validyearduration', function (value, element, params) {
        if (value < 0) {
            return false;
        }
        return true;
    }, '');

    jQuery.validator.unobtrusive.adapters.add('validyearduration', function (options) {
        options.rules['validyearduration'] = {};
        options.messages['validyearduration'] = options.message;
    });

    // The each('abcd..') loop is required to enable client-side validation for RequiredIf because RequiredIf can be
    // applied to a property multiple time and each use of RequiredIf returns a unique ValidationType/Name

    $.each('abcdefghijklmnopqrstuvwxyz'.split(''), function (idx, val) {
        const adapterName = `requiredif${val}`;

        $.validator.unobtrusive.adapters.add(adapterName, ['dependentproperty', 'desiredvalue'], function (options) {
            options.rules[adapterName] = options.params;
            options.messages[adapterName] = options.message;
        });
    });

    $.each('abcdefghijklmnopqrstuvwxyz'.split(''), function (idx, val) {
        const methodName = `requiredif${val}`;

        $.validator.addMethod(methodName, function (value, element, parameters) {
            const dependentPropertyArray = parameters.dependentproperty.split(',');
            const desiredValueArray = parameters.desiredvalue.split(',');
            const elementIsPartOfList = element.name.includes('[') && element.name.includes(']');
            const listPrefix = element.name.substring(0, element.name.lastIndexOf('.'));

            let fieldIsRequired = true;
            for (let i = 0; i < dependentPropertyArray.length; i++) {
                // Find the <input> that we're inspecting; only look in the [Attribute] decorated property's form
                let dependentProperty;
                if (elementIsPartOfList) {
                    dependentProperty = $(element.form).find(`[name='${listPrefix}.${dependentPropertyArray[i]}']`);
                }
                else {
                    dependentProperty = $(element.form).find(`[name='${dependentPropertyArray[i]}']`);
                }
                const desiredDependentValue = desiredValueArray[i] || '';
                let actualDependentValue;

                switch (dependentProperty.attr('type')) {
                    case 'checkbox':
                        actualDependentValue = dependentProperty.is(':checked')
                            ? 'true'
                            : 'false';
                        break;

                    case 'radio':
                        actualDependentValue = dependentProperty.filter(':checked').val() || '';
                        break;

                    default:
                        actualDependentValue = dependentProperty.val() || '';
                        break;
                }

                fieldIsRequired = fieldIsRequired && $.trim(desiredDependentValue).toLowerCase() === $.trim(actualDependentValue).toLocaleLowerCase();
            }

            let isValid = true;
            if (fieldIsRequired) {
                // Check if the required field passes validation
                isValid = $.validator.methods.required.call(this, value, element, parameters);
            }

            return isValid;
        });
    });

    //jQuery.validator.addMethod('date',
    //    function (value, element, params) {
    //        if (this.optional(element)) {
    //            return true;
    //        }

    //        var ok = true;
    //        try {
    //            var test = new Date(Date.parse(value));
    //            util.console.log(test);
    //        }
    //        catch (err) {
    //            ok = false;
    //        }
    //        return ok;
    //    });

    jQuery.validator.addMethod('daterange', function (value, element, parameters) {
        if (value == '' || value == undefined) {
            return true;
        }

        var minimumDateRequiredString = parameters['minimumdaterequired'];
        var maximumDateAllowedString = parameters['maximumdateallowed'];

        //get min date if exists
        var minDate = new Date(-8640000000000000);
        if (minimumDateRequiredString) {
            minDate = new Date(Date.parse(minimumDateRequiredString));
        }

        //get max date if exists
        var maxDate = new Date(8640000000000000);
        if (maximumDateAllowedString) {
            maxDate = new Date(Date.parse(maximumDateAllowedString));
        }

        var valueDate = new Date(Date.parse(value));

        return valueDate >= minDate && valueDate <= maxDate;
    });
    jQuery.validator.unobtrusive.adapters.add('daterange', ['minimumdaterequired', 'maximumdateallowed'], function (options) {
        options.rules['daterange'] = { minimumdaterequired: options.params['minimumdaterequired'], maximumdateallowed: options.params['maximumdateallowed'] };
        options.messages['daterange'] = options.message;
    });

    jQuery.validator.addMethod('requiredifdifferent', function (value, element, parameters) {
        var nameA = '[name="' + parameters['comparepropertya'] + '"]';
        var nameB = '[name="' + parameters['comparepropertyb'] + '"]';

        // get the actual value of the target controls - note - this probably needs to cater for more control types, e.g. radios
        var controlA = $(nameA, element.closest('form'));
        var controlB = $(nameB, element.closest('form'));

        //Assumption is that they are the same type of control
        var controlTypeA = controlA.attr('type');
        var controlTypeB = controlB.attr('type');

        var valA = '';
        if (controlTypeA === 'checkbox') {
            valA = controlA.attr('checked').toString();
        }
        else if (controlA.length > 1 && $(controlA[0]).attr('type') === 'radio') {
            valA = $(nameA + ":checked", element.closest('form')).val();
        }
        else {
            valA = controlA.val();
        }

        var valueB = '';
        if (controlTypeB === 'checkbox') {
            valueB = controlB.attr('checked').toString();
        }
        else if (controlB.length > 1 && $(controlB[0]).attr('type') === 'radio') {
            valueB = $(nameB + ":checked", element.closest('form')).val();
        }
        else {
            valueB = controlB.val();
        }

        valA = (valA === null ? '' : valA).toString();
        valueB = (valueB === null ? '' : valueB).toString();
        // if the condition is true, reuse the existing  required field validator functionality
        if (valA.toLowerCase() !== valueB.toLowerCase()) {
            return $.validator.methods.required.call(this, value, element, parameters);
        }
        return true;
    });

    jQuery.validator.unobtrusive.adapters.add('requiredifdifferent', ['comparepropertya', 'comparepropertyb'], function (options) {
        options.rules['requiredifdifferent'] = { comparepropertya: options.params['comparepropertya'], comparepropertyb: options.params['comparepropertyb'] };
        options.messages['requiredifdifferent'] = options.message;
    });

    jQuery.validator.addMethod('requiredtrue', function (value, element, params) {
        return value === true || value === 'true';
    }, '');

    jQuery.validator.unobtrusive.adapters.add('requiredtrue', function (options) {
        options.rules['requiredtrue'] = {};
        options.messages['requiredtrue'] = options.message;
    });

    jQuery.validator.addMethod('requiredatleastone', function (value, element, parameters) {
        //get the name of the list of elements
        var name = '[name^="' + element.name + '"]:checked';
        var controls = $(name, element.closest('form'));
        return controls.length > 0;
    });

    jQuery.validator.unobtrusive.adapters.add('requiredatleastone', function (options) {
        options.rules['requiredatleastone'] = {};
        options.messages['requiredatleastone'] = options.message;
    });

    jQuery.validator.addMethod('requirednotnull', function (value, element, params) {
        return !(value === null);
    }, '');

    jQuery.validator.addMethod('requirednotnull', function (value, element, parameters) {
        var noParams = true;

        if (typeof parameters['dependentproperty'] !== 'undefined') {
            noParams = parameters['dependentproperty'] === '';
        }

        if (noParams) {
            return value !== null;
        } else {
            var name = "[name='" + parameters['dependentproperty'] + "']";
            var control = $(name, element.closest('form'));
            var controltype = control.attr('type');

            var actualvalue = '';
            if (controltype === 'checkbox') {
                if (control.is(':checked')) {
                    actualvalue = 'True';
                } else {
                    actualvalue = 'False';
                }
            }
            else if (control.length > 1 && $(control[0]).attr('type') === 'radio') {
                return $(name + ":checked", element.closest('form')).length === 1;
            }
            else {
                actualvalue = control.val();
            }

            if (actualvalue === '') {
                return value === null;
            }
        }
        return true;
    });
    //}, "");

    jQuery.validator.unobtrusive.adapters.add('requirednotnull', ['dependentproperty'], function (options) {
        options.rules['requirednotnull'] = { dependentproperty: options.params['dependentproperty'] };
        options.messages['requirednotnull'] = options.message;
    });

    jQuery.validator.unobtrusive.adapters.add('requirednotnull', ['dependentproperty'], function (options) {
        options.rules['requirednotnull'] = { dependentproperty: options.params['dependentproperty'] };
        options.messages['requirednotnull'] = options.message;
    });

    // extend jquery range validator to work for required checkboxes
    var defaultRangeValidator = $.validator.methods.range;
    $.validator.methods.range = function (value, element, param) {
        if (element.type === 'checkbox') {
            // if it's a checkbox return true if it is checked
            return element.checked;
        } else {
            // otherwise run the default validation function
            return defaultRangeValidator.call(this, value, element, param);
        }
    };

    $.validator.unobtrusive.adapters.add('requirelist', ['minselections', 'maxselections'], function (options) {
        options.rules['requirelist'] = options.params;
        options.messages['requirelist'] = options.message;
    });

    $.validator.addMethod('requirelist', function (value, element, parameters) {
        var minNumber = parameters.minselections;
        var maxNumber = parameters.maxselections;

        var listName = element.name; // 'name' for the list of selected options
        var selector = `[name^="${listName}"]:checked`; // jQuery selector for checked items
        var controls = $(selector, element.closest('form')); // all checked items in this form

        // if maxNumber != "", null, undefined, etc.
        if (maxNumber) {
            return controls.length >= minNumber && controls.length <= maxNumber;
        }
        else {
            return controls.length >= minNumber;
        }
    });

    $.validator.unobtrusive.adapters.add('requirednotequalto', ['comparevalue'], function (options) {
        options.rules['requirednotequalto'] = options.params;
        options.messages['requirednotequalto'] = options.message;
    });

    $.validator.addMethod('requirednotequalto', function (value, element, parameters) {
        if (value == '') {
            return true;
        }
        return value != parameters.comparevalue;
    });

    jQuery.validator.addMethod("datemustbebeforeotherdate", function (value, element, params) {
        const acceptNull = params["acceptnull"];

        const name = "[name='" + params["propertyname"] + "']";
        const control = $(name, element.closest('form'));

        if ((value === "" || value == undefined) && acceptNull) {
            return true;
        } else if ((value === "" || value == undefined) && !acceptNull) {
            return false;
        }

        // if second date is empty, return true because there is nothing to compare to
        // requirement of that field is handled by a different validator
        if (control.val() === undefined || control.val() === "") return true;

        const propertyDateYear = control.val().substring(3, 7);
        const propertyDateMonth = control.val().substring(0, 2);
        const propertyDate = new Date(propertyDateYear, propertyDateMonth - 1);

        const valueDateYear = value.substring(3, 7);
        const valueDateMonth = value.substring(0, 2);
        const valueDate = new Date(valueDateYear, valueDateMonth - 1);

        //check values
        return valueDate < propertyDate;
    }, "");

    jQuery.validator.unobtrusive.adapters.add("datemustbebeforeotherdate", ["propertyname", "acceptnull"], function (options) {
        options.rules["datemustbebeforeotherdate"] = options.params;
        options.messages["datemustbebeforeotherdate"] = options.message;
    });

    //This is a new custom validator that let's you tell unobtrusive whether a field is valid or invalid based on your custom js logic. Typically used when valid is only true after an ajax request.
    $.validator.unobtrusive.adapters.addBool("fieldisvalid");

    $.validator.addMethod("fieldisvalid", function (value, element) {
        return this.optional(element) || $(element)[0].dataset.fieldisvalid === "true";
    });

    jQuery.validator.addMethod('stringlengthignorecharacters', function (value, element, parameters) {

        var minCount = parseInt(parameters['mincount'],10);
        var maxCount = parseInt(parameters['maxcount'],10);
        var excludedCharacters = parameters['excludedcharacters'].split(",");
        var theString = value;

        for (var i = 0; i < excludedCharacters.length; i++) {
            theString = theString.replaceAll(excludedCharacters[i], "");
        }

        var length = theString.length;

        if (minCount && maxCount) {
            return minCount <= length <= maxCount;
        }

        if (minCount) {
            return minCount <= length;
        }

        if (maxCount) {
            return length <= maxCount;
        }

        return true;
    });

    jQuery.validator.unobtrusive.adapters.add('stringlengthignorecharacters', ['mincount', 'maxcount', 'excludedcharacters'], function (options) {
        options.rules['stringlengthignorecharacters'] = { mincount: options.params['mincount'], maxcount: options.params['maxcount'], excludedcharacters: options.params['excludedcharacters']};
        options.messages['stringlengthignorecharacters'] = options.message;
    });

    //helper function for the new fieldisvalid ubobtrusive validation.
    $.fn.extend({
        toggleFieldIsValid: function (value) {
            this[0].dataset.fieldisvalid = value;
            $.validator.unobtrusive.parse($(this).closest('form'));
            $(this).closest('form').data('validator').element('#' + $(this).attr('id'));
            $(this).valid();
        }
    });
}(jQuery));